@if (panelOpen()) {
  <div
    class="fixed inset-0 bg-black/20 z-[900] transition-opacity duration-300"
    (click)="close()"
  ></div>
}

<div
  class="fixed top-0 right-0 h-full w-[400px] max-w-[90vw] bg-white shadow-[-4px_0_24px_rgba(0,0,0,0.08)] z-[1000] transform transition-transform duration-300 ease-out overflow-y-auto"
  [class.translate-x-0]="panelOpen()"
  [class.translate-x-full]="!panelOpen()"
>
  <div
    class="sticky top-0 bg-white border-b border-slate-200 px-5 py-4 flex items-center justify-between z-10"
  >
    <h2 class="text-lg font-bold text-gray-900">Project Guide</h2>
    <button
      type="button"
      (click)="close()"
      class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors cursor-pointer"
      aria-label="Close guide"
    >
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>

  <div class="px-5 py-4 space-y-1">
    @for (stage of GUIDE_CONTENT; track stage.label) {
      <div class="border border-slate-200 rounded-xl overflow-hidden">
        <button
          type="button"
          (click)="toggleStage(stage.label)"
          class="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-slate-50 transition-colors cursor-pointer"
          [class.bg-slate-50]="isStageExpanded(stage.label)"
        >
          <span class="font-semibold text-sm text-gray-900">{{ stage.label }}</span>
          <svg
            class="w-4 h-4 text-slate-400 transition-transform duration-200"
            [class.rotate-180]="isStageExpanded(stage.label)"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        @if (isStageExpanded(stage.label)) {
          <div class="border-t border-slate-100 divide-y divide-slate-100">
            @for (section of stage.sections; track section.id) {
              <div
                [id]="'guide-section-' + section.id"
                class="px-4 py-3.5"
                [class.bg-secondary/5]="isSectionActive(section.id)"
              >
                <h3 class="text-sm font-bold text-gray-900 mb-1.5">{{ section.heading }}</h3>
                <p class="text-xs text-gray-600 leading-relaxed mb-2">{{ section.shortHelp }}</p>

                @if (section.whyItMatters) {
                  <div class="mb-2">
                    <h4 class="text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1">
                      Why it matters
                    </h4>
                    <p class="text-xs text-gray-600 leading-relaxed">{{ section.whyItMatters }}</p>
                  </div>
                }

                @if (section.howItWorks && section.howItWorks.length > 0) {
                  <div class="mb-2">
                    <h4 class="text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1">
                      How it works
                    </h4>
                    <ul class="space-y-1">
                      @for (item of section.howItWorks; track item) {
                        <li class="flex items-start gap-1.5 text-xs text-gray-600">
                          <span class="text-secondary mt-0.5 flex-shrink-0">&bull;</span>
                          <span>{{ item }}</span>
                        </li>
                      }
                    </ul>
                  </div>
                }

                @if (section.prismaMapping) {
                  <div class="mb-2">
                    <h4 class="text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1">
                      PRISMA 2020
                    </h4>
                    <p class="text-xs text-gray-600 leading-relaxed">{{ section.prismaMapping }}</p>
                  </div>
                }

                @if (section.nextStage) {
                  <p class="text-xs text-slate-400">Next stage: {{ section.nextStage }}</p>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
